export const UPDATE_SITE_DATA = 'UPDATE_SITE_DATA';
export const NAVIGATE_TO_PATH = 'NAVIGATE_TO_PATH';
export const ADD_DOCUMENT_ELEMENTS = 'ADD_DOCUMENT_ELEMENTS';
export const RESET_SHOPPING_CART_ITEMS = 'RESET_SHOPPING_CART_ITEMS';
